<app-popup></app-popup>
<app-tooltip></app-tooltip>
<app-loading></app-loading>

<div class="container-scroller">
    <app-navbar #navbar *ngIf="authService.userHasLoggedIn" [appComponent]="component"></app-navbar>
    <div
        #pageBodyWrapper
        class="container-fluid page-body-wrapper">
        <div #mainPanel class="main-panel">
            <div #contentWrapper class="content-wrapper">
                <div style="min-height: 500px;">
                    <router-outlet></router-outlet>
                </div>

                <app-footer *ngIf="authService.userHasLoggedIn && !isWizardRoute && !isPricingRoute"></app-footer>
            </div>
        </div>
    </div>
    <app-mobilebar *ngIf="authService.userHasLoggedIn && !isWizardRoute && !isPricingRoute"></app-mobilebar>
</div>
